module.exports = __webpack_public_path__ + "static/media/paco-rabanne-one-million-prive-big.bf585e9b.png";